import actionTypes from './actionTypes';

const INIT_STATE = {
  createRseePackageRequestLoading: false,
  createRseePackageRequestFailed: false,
  createRseePackageRequestError: false,
  createRseePackageRequestMessage: '',

  updateRseePackageLoading: false,
  updateRseePackageFailed: false,
  updateRseePackageError: false,
  updateRseePackageMessage: '',

  getRseePackageByIdLoading: false,
  getRseePackageByIdFailed: false,
  getRseePackageByIdError: false,
  getRseePackageByIdMessage: '',
  packageById: [],

  getRseePackagesListLoading: false,
  getRseePackagesListFailed: false,
  getRseePackagesListError: false,
  getRseePackagesListMessage: '',
  rseePackagesList: [],
  rseePackagesTotalRecords: 0,

  getRseePackagesSalesReportLoading: false,
  getRseePackagesSalesReportFailed: false,
  getRseePackagesSalesReportError: false,
  getRseePackagesSalesReportMessage: '',
  rseePackagesSalesReport: [],
  rseePackagesSalesReportTotalRecords: 0,
  sumTotalPaidPrice: 0,
  sumTotalBoughtRsee: 0,

  updateRseePackageStatusLoading: false,
  updateRseePackageStatusFailed: false,
  updateRseePackageStatusError: false,
  updateRseePackageStatusMessage: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case actionTypes.CREATE_RSEE_PACKAGE_REQUEST_LOADING: {
      return {
        ...state,
        createRseePackageRequestLoading: true,
        createRseePackageRequestFailed: false,
        createRseePackageRequestError: false,
        createRseePackageRequestMessage: '',
      };
    }
    case actionTypes.CREATE_RSEE_PACKAGE_REQUEST_SUCCESS: {
      return {
        ...state,
        createRseePackageRequestLoading: false,
        createRseePackageRequestFailed: false,
        createRseePackageRequestError: false,
        createRseePackageRequestMessage: '',
      };
    }
    case actionTypes.CREATE_RSEE_PACKAGE_REQUEST_REJECT: {
      return {
        ...state,
        createRseePackageRequestLoading: false,
        createRseePackageRequestFailed: false,
        createRseePackageRequestError: true,
        createRseePackageRequestMessage: '',
      };
    }
    case actionTypes.CREATE_RSEE_PACKAGE_REQUEST_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        createRseePackageRequestLoading: false,
        createRseePackageRequestFailed: true,
        createRseePackageRequestError: false,
        createRseePackageRequestMessage: message,
      };
    }

    case actionTypes.UPDATE_RSEE_PACKAGE_REQUEST_LOADING: {
      return {
        ...state,
        updateRseePackageLoading: true,
        updateRseePackageFailed: false,
        updateRseePackageError: false,
        updateRseePackageMessage: '',
      };
    }
    case actionTypes.UPDATE_RSEE_PACKAGE_REQUEST_SUCCESS: {
      return {
        ...state,
        updateRseePackageLoading: false,
        updateRseePackageFailed: false,
        updateRseePackageError: false,
        updateRseePackageMessage: '',
      };
    }
    case actionTypes.UPDATE_RSEE_PACKAGE_REQUEST_REJECT: {
      return {
        ...state,
        updateRseePackageLoading: false,
        updateRseePackageFailed: false,
        updateRseePackageError: true,
        updateRseePackageMessage: '',
      };
    }
    case actionTypes.UPDATE_RSEE_PACKAGE_REQUEST_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        updateRseePackageLoading: false,
        updateRseePackageFailed: true,
        updateRseePackageError: false,
        updateRseePackageMessage: message,
      };
    }

    case actionTypes.GET_RSEE_PACKAGE_BY_ID_LOADING: {
      return {
        ...state,
        getRseePackageByIdLoading: true,
        getRseePackageByIdFailed: false,
        getRseePackageByIdError: false,
        getRseePackageByIdMessage: '',
        packageById: [],
      };
    }
    case actionTypes.GET_RSEE_PACKAGE_BY_ID_SUCCESS: {
      return {
        ...state,
        getRseePackageByIdLoading: false,
        getRseePackageByIdFailed: false,
        getRseePackageByIdError: false,
        getRseePackageByIdMessage: '',
        packageById: action.payload,
      };
    }
    case actionTypes.GET_RSEE_PACKAGE_BY_ID_REJECT: {
      return {
        ...state,
        getRseePackageByIdLoading: false,
        getRseePackageByIdFailed: false,
        getRseePackageByIdError: true,
        getRseePackageByIdMessage: '',
        packageById: [],
      };
    }
    case actionTypes.GET_RSEE_PACKAGE_BY_ID_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getRseePackageByIdLoading: false,
        getRseePackageByIdFailed: true,
        getRseePackageByIdError: false,
        getRseePackageByIdMessage: message,
        packageById: [],
      };
    }

    case actionTypes.GET_ALL_RSEE_PACKAGES_REQUESTS_LOADING: {
      return {
        ...state,
        getRseePackagesListLoading: true,
        getRseePackagesListFailed: false,
        getRseePackagesListError: false,
        getRseePackagesListMessage: '',
        rseePackagesList: [],
        rseePackagesTotalRecords: 0,
      };
    }
    case actionTypes.GET_ALL_RSEE_PACKAGES_REQUESTS_SUCCESS: {
      return {
        ...state,
        getRseePackagesListLoading: false,
        getRseePackagesListFailed: false,
        getRseePackagesListError: false,
        getRseePackagesListMessage: '',
        rseePackagesList: [...action.payload.rseePackages],
        rseePackagesTotalRecords: action.payload.totalRecords,
      };
    }
    case actionTypes.GET_ALL_RSEE_PACKAGES_REQUESTS_REJECT: {
      return {
        ...state,
        getRseePackagesListLoading: false,
        getRseePackagesListFailed: false,
        getRseePackagesListError: true,
        getRseePackagesListMessage: '',
        rseePackagesList: [],
        rseePackagesTotalRecords: 0,
      };
    }
    case actionTypes.GET_ALL_RSEE_PACKAGES_REQUESTS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getRseePackagesListLoading: false,
        getRseePackagesListFailed: true,
        getRseePackagesListError: false,
        getRseePackagesListMessage: message,
        rseePackagesList: [],
        rseePackagesTotalRecords: 0,
      };
    }

    case actionTypes.GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_LOADING: {
      return {
        ...state,
        getRseePackagesSalesReportLoading: true,
        getRseePackagesSalesReportFailed: false,
        getRseePackagesSalesReportError: false,
        getRseePackagesSalesReportMessage: '',
        rseePackagesSalesReport: [],
        rseePackagesSalesReportTotalRecords: 0,
        sumTotalPaidPrice: 0,
        sumTotalBoughtRsee: 0,
      };
    }
    case actionTypes.GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_SUCCESS: {
      return {
        ...state,
        getRseePackagesSalesReportLoading: false,
        getRseePackagesSalesReportFailed: false,
        getRseePackagesSalesReportError: false,
        getRseePackagesSalesReportMessage: '',
        rseePackagesSalesReport: [...action.payload.rseePackagesReports],
        sumTotalPaidPrice: action.payload.sumTotalPaidPrice,
        sumTotalBoughtRsee: action.payload.sumTotalBoughtRsee,
        rseePackagesSalesReportTotalRecords: action.payload.totalRecords,
      };
    }
    case actionTypes.GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_REJECT: {
      return {
        ...state,
        getRseePackagesSalesReportLoading: false,
        getRseePackagesSalesReportFailed: false,
        getRseePackagesSalesReportError: true,
        getRseePackagesSalesReportMessage: '',
        rseePackagesSalesReport: [],
        rseePackagesSalesReportTotalRecords: 0,
        sumTotalPaidPrice: 0,
        sumTotalBoughtRsee: 0,
      };
    }
    case actionTypes.GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getRseePackagesSalesReportLoading: false,
        getRseePackagesSalesReportFailed: true,
        getRseePackagesSalesReportError: false,
        getRseePackagesSalesReportMessage: message,
        rseePackagesSalesReport: [],
        rseePackagesSalesReportTotalRecords: 0,
        sumTotalPaidPrice: 0,
        sumTotalBoughtRsee: 0,
      };
    }

    case actionTypes.UPDATE_RSEE_PACKAGE_STATUS_LOADING: {
      return {
        ...state,
        updateRseePackageStatusLoading: true,
        updateRseePackageStatusFailed: false,
        updateRseePackageStatusError: false,
        updateRseePackageStatusMessage: '',
      };
    }
    case actionTypes.UPDATE_RSEE_PACKAGE_STATUS_SUCCESS: {
      return {
        ...state,
        updateRseePackageStatusLoading: false,
        updateRseePackageStatusFailed: false,
        updateRseePackageStatusError: false,
        updateRseePackageStatusMessage: '',
      };
    }
    case actionTypes.UPDATE_RSEE_PACKAGE_STATUS_REJECT: {
      return {
        ...state,
        updateRseePackageStatusLoading: false,
        updateRseePackageStatusFailed: false,
        updateRseePackageStatusError: true,
        updateRseePackageStatusMessage: '',
      };
    }
    case actionTypes.UPDATE_RSEE_PACKAGE_STATUS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        updateRseePackageStatusLoading: false,
        updateRseePackageStatusFailed: true,
        updateRseePackageStatusError: false,
        updateRseePackageStatusMessage: message,
      };
    }

    default: {
      return { ...state };
    }
  }
};
